import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { CountdownGlobalConfig, CountdownModule } from 'ngx-countdown';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { HomeComponent } from './home/home.component';
import { LandingComponent } from './landing/landing.component';
import { MissionsComponent } from "../component/missions/missions.component";
import { MymissionsComponent } from './mymissions/mymissions.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { RewardsComponent } from './rewards/rewards.component';
import { ProfileComponent } from './profile/profile.component';
import { InventoryComponent } from './inventory/inventory.component';
import { ExpbarComponent } from "../component/expbar/expbar.component";
import { InventoryitemsComponent } from "../component/inventoryitems/inventoryitems.component";
import { MyinventoryComponent } from "../component/myinventory/myinventory.component";
import { SkillsbarsComponent } from "../component/skillsbars/skillsbars.component";
import { MyitemsComponent } from './myitems/myitems.component';
import { SeasonrewardsComponent } from "../component/seasonrewards/seasonrewards.component";
import { HotitemsComponent } from "../component/hotitems/hotitems.component";
import { MypacksComponent } from "../component/mypacks/mypacks.component";
import { PackbuyComponent } from "../component/packbuy/packbuy.component";
import { BuffsComponent } from "../component/buffs/buffs.component";
import { PassComponent } from "../component/pass/pass.component";
import { MypassComponent } from "../component/mypass/mypass.component";
import { ProfileeditComponent } from "../component/profileedit/profileedit.component";
import { ArtifactsComponent } from "../component/artifacts/artifacts.component";
import { AuctionhouseComponent } from './auctionhouse/auctionhouse.component';
import { AuctionlistingsComponent } from "../component/auctionlistings/auctionlistings.component";
import { MysellableComponent } from "../component/mysellable/mysellable.component";
import { ShareprofileComponent } from "../component/shareprofile/shareprofile.component";

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    CarouselModule,
    CountdownModule
  ],
  declarations: [
    HomeComponent,
    LandingComponent,
    MissionsComponent,
    MymissionsComponent,
    LeaderboardComponent,
    RewardsComponent,
    ProfileComponent,
    InventoryComponent,
    ExpbarComponent,
    InventoryitemsComponent,
    MyinventoryComponent,
    SkillsbarsComponent,
    MyitemsComponent,
    SeasonrewardsComponent,
    HotitemsComponent,
    MypacksComponent,
    PackbuyComponent,
    BuffsComponent,
    PassComponent,
    MypassComponent,
    ProfileeditComponent,
    ArtifactsComponent,
    AuctionhouseComponent,
    AuctionlistingsComponent,
    MysellableComponent,
    ShareprofileComponent
  ],
  exports: [

  ],
  providers: [
  ]
})
export class PagesModule { }
